import { render } from "./FinancialHealthQuiz.vue?vue&type=template&id=891d7fa4&scoped=true"
import script from "./FinancialHealthQuiz.vue?vue&type=script&lang=js"
export * from "./FinancialHealthQuiz.vue?vue&type=script&lang=js"

import "./FinancialHealthQuiz.vue?vue&type=style&index=0&id=891d7fa4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891d7fa4"]])

export default __exports__